import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Google16 = ({
  height = 16,
  width = 16,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M11.5584 9.57494H8.85759V7.14244H14.5626V8.34411C14.4798 9.85765 13.8765 11.2961 12.8549 12.4159C11.8333 13.5357 10.4562 14.2681 8.95654 14.489C7.45694 14.71 5.92705 14.4059 4.62588 13.6284C3.32471 12.8508 2.33221 11.6475 1.8164 10.2222C1.3006 8.79682 1.29318 7.23703 1.79541 5.80685C2.29764 4.37667 3.27866 3.16398 4.57237 2.37409C5.86609 1.58419 7.39302 1.26562 8.89466 1.4723C10.3963 1.67899 11.7804 2.39824 12.8126 3.50828L10.8293 5.33411C10.4673 4.94629 10.0292 4.63733 9.54244 4.42654C9.05563 4.21576 8.53057 4.1077 8.00009 4.10911C7.2995 4.10921 6.61194 4.29846 6.00998 4.6569C5.40803 5.01534 4.91402 5.52966 4.58012 6.14556C4.24622 6.76146 4.08481 7.4561 4.11293 8.15612C4.14105 8.85615 4.35766 9.53559 4.73989 10.1227C5.12212 10.7099 5.65579 11.1829 6.28456 11.4919C6.91333 11.8009 7.61386 11.9344 8.3122 11.8783C9.01054 11.8222 9.68078 11.5786 10.2521 11.1731C10.8235 10.7677 11.2748 10.2156 11.5584 9.57494V9.57494Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.60515 6.08078L2.51099 4.40662"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.61091 9.93665L2.60425 11.745"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2869 11.1442L12.0777 13.1567"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.57007 9.57996H11.5701"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
